@import '../../../../../../constants/spacing.module.less';

.title-wrapper {
  justify-content: space-between;
  padding-top: @space-24;
}

.pointer {
  cursor: pointer;
}

.edit-button {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.edit-svg {
  height: 14px;
  width: 14px;
}

.step-title-with-check {
  gap: @space-16;
  align-items: center;
}

.start-button {
  align-items: center;
  color: var(--gray-818F9C);

  svg {
    height: 16px;
    width: 16px;
    margin-left: @space-4;
  }
}

.chevron {
  height: 16px;
  width: 16px;
  color: var(--gray-637381);
}
